// removed by extract-text-webpack-plugin
module.exports = {"base":"_H11S","heading":"q6OvP","top":"_2ZWSQ","customerImg":"_2cj6M","bottom":"dpWF3","separater":"_1cs5o","newsDate":"_3ODdI","content":"_3maEe","stats":"_11Nlv","title":"AUL7I","description":"_1bnIj","footer":"_1sI7D","duration":"_3HfUb","callToAction":"_3MTwN","newsContainer":"_3x_5_","section":"_1eFmn","sectionTitle":"A8MDX","cardContentHeight":"_1e_Rp","cardFooter":"_2Wy28"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/Tile/Tile.scss
// module id = 1773
// module chunks = 0